import AnimatedComponent from "./animatedComponent"

/**
 * 
 * @version 1.0.1
 * @see Scrollbar
 * @see AnimatedComponent
 * 
 * @param {HTMLElement} element 
 * @param {object} options 
 * @returns {SlidePanel} slidepanel - экземпляр класса
 */
class SlidePanel extends AnimatedComponent {

    constructor(element, options = {}) {

        if (!element) {
            console.error('element not found')
            return false
        }
        
        let state_list = {
            visibility: ['closed', 'open'],
            position: ['left', 'right'],
        }
        let state_active_list = {
            visibility: 'closed',
            position: 'left',
        }
        let state_status_list = {
            visibility: true,
            position: true,
        }
        if (options.state_status_list) state_status_list = {...state_status_list, ...options.state_status_list}
        super(element, state_list, state_active_list, state_status_list, options)

        let options_default = {
            selectors: {
                handler: '[data-sp="handler"]',
                panel: '[data-sp="panel"]',
                contentContainer: '[data-sp="container"]',
                scrollContainer: '[data-sp="scroll-container"]',
            },
        }
        this.options = {...options_default, ...options}

        // элементы управления
        this.handlers = Array.from(element.querySelectorAll(this.options.selectors.handler))
        // элементы
        this.element = element
        this.elements = {
            component: element,
            // основной видимый элемень панели
            panel: element.querySelector(this.options.selectors.panel),
            // куда вставлять контент
            contentContainer: element.querySelector(this.options.selectors.contentContainer),
            // скрол-контейнер. Должен иметь фиксированную ширину. К нему применяется simplebar
            scrollContainer: element.querySelector(this.options.selectors.scrollContainer),
        }

        // куда возвращать вставленный контент
        this.contentReturnElement = null
        // добавочный класс контента
        this.contentClassName = ''
        // если true - после закрытия контент кладется на место
        this.insertOnce = false

        // объект скролбара используется для сокрытия скролбара при открытии
        this.scrollbar = window.scrollbar || null

        // идентификатор вставляемого контента
        this.contentID = 0

        this.handlers.forEach(handler => {
            handler.addEventListener('click', (e) => {
                this.toggle()
            })
        })

        this.toggle.bind(this)
    }

    insert( element, id=null, className='', insertOnce=false ) {
        if (!element) return
        let current_content = this.getContent()
        if ( element === current_content ) {
            return
        }
        // возвращаем текущий контент на место
        this.takeout()

        // вставляем элемент
        if ( className ) {
            this.contentClassName = className
            element.classList.add( className )
        }
        this.contentReturnElement = element.parentElement
        this.elements.contentContainer.append(element)
        this.contentID = id
        this.insertOnce = !!insertOnce
    }

    takeout() {
        // возвращаем текущий контент на место
        let current_content = this.getContent()
        if ( this.contentReturnElement && current_content ) {
            if ( this.contentClassName ) {
                current_content.classList.remove( this.contentClassName )
            }
            this.contentReturnElement.append( current_content )
            this.contentReturnElement = null
        }
    }

    setContentWidth( width=null, unit='px' ) {
        if ( width === null ) {
            this.elements.scrollContainer.style.width = ''
        } else {
            this.elements.scrollContainer.style.width = +width+unit
        }
    }

    getContent() {
        return this.elements.contentContainer.children[0]
    }

    removeContent() {
        let content = this.getContent()
        if ( content ) {
            content.remove()
            console.log('remove content')
        }
    }

    open() {
        this.element.dispatchEvent(new CustomEvent('slidePanelBeforeChangeState', {
            bubbles:true,
            cancelable:true,
            detail: {
                width: this.element.offsetWidth,
                state: 'open',
                contentID: this.contentID,
            }
        }))
        this.scrollbar && this.scrollbar.off()
        return this.changeState('visibility', 'open', this.elements.component, true)
            .then((status)=>{
                if (status) {
                    this.element.dispatchEvent(new CustomEvent('slidePanelAfterChangeState', {
                        bubbles:true,
                        cancelable:true,
                        detail: {
                            width: this.element.offsetWidth,
                            state: 'open',
                            contentID: this.contentID,
                        }
                    }))
                }
            })
    }

    close() {
        this.element.dispatchEvent(new CustomEvent('slidePanelBeforeChangeState', {
            bubbles:true,
            cancelable:true,
            detail: {
                width: this.element.offsetWidth,
                state: 'close',
                contentID: this.contentID,
            }
        }))
        return this.changeState('visibility', 'closed', this.elements.component, true)
            .then((status)=>{
                this.scrollbar && this.scrollbar.on()
                if (status) {
                    this.element.dispatchEvent(new CustomEvent('slidePanelAfterChangeState', {
                        bubbles:true,
                        cancelable:true,
                        detail: {
                            width: this.element.offsetWidth,
                            state: 'close',
                            contentID: this.contentID,
                        }
                    }))
                }
            })
            .then((status)=>{
                if (this.insertOnce) {
                    this.takeout()
                    this.insertOnce = false
                }
            })
    }

    toggle() {
        let state_group = this._getStateGroup('visibility')
        if (!state_group) return false

        if ( !state_group.is_in_process && state_group.current_state_name === 'closed' ) {
            this.open()
        } else if ( !state_group.is_in_process && state_group.current_state_name === 'open' ) {
            this.close()
        }
    }

    addHandler(element) {
        if (!element) return
        this.handlers.push(element)

        element.addEventListener('click', (e) => {
            this.toggle()
        })
    }
}

export default SlidePanel